import type { DocumentTypeSectionFieldPayload } from '@Application/Organizations/Workflows/Actions/documentTypeSectionsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One field of a template section, addressed by its path.
 */
class DocumentTypeSectionFieldView {
	readonly path: string;
	readonly label: string;

	constructor(payload: DocumentTypeSectionFieldPayload) {
		this.path = payload.path;
		this.label = payload.label;

		Object.freeze(this);
	}
}

export default DocumentTypeSectionFieldView;
